import React, { useEffect, useState } from "react";
import { $host } from "../../../../http";
import ThemeCard from "../../components/cards/ThemeCard";
import CreateThemeModal from "../../components/modal/CreateThemeModal";

const Themes = () => {
    const [themes, setThemes] = useState([]);
    const [filteredThemes, setFilteredThemes] = useState([]);
    const [courses, setCourses] = useState({});
    const [paragraphs, setParagraphs] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [error, setError] = useState(null);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            // Получаем темы преподавателя
            const themesResponse = await $host.get("/api/teachers/themes", { withCredentials: true });
            setThemes(themesResponse.data);
            setFilteredThemes(themesResponse.data);

            // Получаем курсы преподавателя
            const coursesResponse = await $host.get("/api/teachers/courses", { withCredentials: true });
            const coursesData = coursesResponse.data.reduce((acc, course) => {
                acc[course.id] = course;
                return acc;
            }, {});
            setCourses(coursesData);

            // Получаем параграфы преподавателя
            const paragraphsResponse = await $host.get("/api/teachers/paragraphs", { withCredentials: true });
            const paragraphsData = paragraphsResponse.data.reduce((acc, paragraph) => {
                acc[paragraph.id] = paragraph;
                return acc;
            }, {});
            setParagraphs(paragraphsData);
        } catch (err) {
            setError(err.response?.data?.message || err.message);
        }
    };

    // Фильтр тем при изменении строки поиска
    useEffect(() => {
        if (!searchQuery) {
            setFilteredThemes(themes);
        } else {
            const lowerQuery = searchQuery.toLowerCase();
            const matchedThemes = themes.filter((theme) =>
                theme.title.toLowerCase().includes(lowerQuery)
            );
            setFilteredThemes(matchedThemes);
        }
    }, [searchQuery, themes]);

    // Группируем темы по курсам и параграфам
    const groupedThemes = filteredThemes.reduce((acc, theme) => {
        const paragraph = paragraphs[theme.paragraph_id] || {};
        const course = courses[paragraph.course_id] || {};

        const courseKey = `${course.id}::${course.title}`;
        const paragraphKey = `${paragraph.id}::${paragraph.title}`;

        if (!acc[courseKey]) acc[courseKey] = {};
        if (!acc[courseKey][paragraphKey]) acc[courseKey][paragraphKey] = [];

        acc[courseKey][paragraphKey].push(theme);
        return acc;
    }, {});

    // Функция удаления темы
    const handleDeleteTheme = async (themeId) => {
        if (!window.confirm("Вы уверены, что хотите удалить эту тему?")) return;

        try {
            await $host.delete(`/api/teachers/themes/${themeId}`, { withCredentials: true });

            setThemes((prevThemes) => prevThemes.filter((theme) => theme.id !== themeId));
        } catch (error) {
            console.error("Ошибка удаления темы:", error.response?.data?.message || error.message);
        }
    };

    // Добавление новой темы
    const handleThemeCreated = (newTheme) => {
        setThemes((prevThemes) => [...prevThemes, newTheme]);
        setIsCreateModalOpen(false);
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold">Список тем</h2>
                <div className="flex gap-4">
                    <input
                        type="text"
                        placeholder="🔎 Поиск темы..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="p-2 border rounded-md"
                    />
                    <button
                        onClick={() => setIsCreateModalOpen(true)}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md"
                    >
                        ➕ Создать тему
                    </button>
                </div>
            </div>

            {error && <p className="text-red-500">Ошибка: {error}</p>}
            {filteredThemes.length === 0 ? (
                <p className="text-gray-600">Загрузка или нет данных...</p>
            ) : (
                <div className="space-y-6">
                    {Object.keys(groupedThemes).map((courseKey) => {
                        const [courseId, courseTitle] = courseKey.split("::");
                        return (
                            <div key={courseId}>
                                <h3 className="text-xl font-bold mb-4">{courseTitle}</h3>
                                {Object.keys(groupedThemes[courseKey]).map((paragraphKey) => {
                                    const [paragraphId, paragraphTitle] = paragraphKey.split("::");
                                    return (
                                        <div key={paragraphId} className="mb-6">
                                            <h4 className="text-lg font-semibold mb-2">{paragraphTitle}</h4>
                                            <div className="flex flex-wrap gap-4">
                                                {groupedThemes[courseKey][paragraphKey].map((theme) => (
                                                    <ThemeCard
                                                        key={theme.id}
                                                        id={theme.id}
                                                        title={theme.title}
                                                        questionCount={theme.question_count || 0}
                                                        webinarRoomId={theme.webinar_room_id}
                                                        webinarPreviewUrl={theme.webinar_preview_url} // ✅ Передаем превью прямо из темы
                                                        onDelete={handleDeleteTheme}
                                                        onUpdate={(id, updatedData) => {
                                                            setThemes((prevThemes) =>
                                                                prevThemes.map((t) =>
                                                                    t.id === id ? { ...t, ...updatedData } : t // ⬅️ добавлено `: t`
                                                                )
                                                            );
                                                        }}

                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Модалка создания темы */}
            <CreateThemeModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                onThemeCreated={handleThemeCreated}
            />
        </div>
    );
};

export default Themes;
